import { render, staticRenderFns } from "./SchoolHourPriceIndex.vue?vue&type=template&id=28422516&scoped=true&"
import script from "./SchoolHourPriceIndex.vue?vue&type=script&lang=js&"
export * from "./SchoolHourPriceIndex.vue?vue&type=script&lang=js&"
import style0 from "./SchoolHourPriceIndex.vue?vue&type=style&index=0&id=28422516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28422516",
  null
  
)

export default component.exports